import React, { useState, useEffect } from 'react';
import { Card, Col, Row, Button, Spinner, Modal } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import ProgramService from './ProgramService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import corner4 from 'assets/img/illustrations/corner-4.png';
import { Badge } from 'react-bootstrap';
import Background from 'components/common/Background';

const ImportFromPDF = () => {
  // Implement your PDF import logic here
  console.log('Importing from PDF...');
  const [pdfFile, setPdfFile] = useState(null);
  const [isImporting, setIsImporting] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [dataImported, setDataImported] = useState(null);
  const [selectedClasses, setSelectedClasses] = useState({});
  const [isSavingClasses, setIsSavingClasses] = useState(false);
  const handleFileChange = event => {
    setPdfFile(event.target.files[0]);
  };
  const handleToggleClass = classIndex => {
    setSelectedClasses(prev => ({
      ...prev,
      [classIndex]: !prev[classIndex]
    }));
  };

  const handleSelectAll = () => {
    const newSelection = {};
    dataImported.forEach((_, index) => {
      newSelection[index] = true;
    });
    setSelectedClasses(newSelection);
  };

  const handleUnselectAll = () => {
    const newSelection = {};
    dataImported.forEach((_, index) => {
      newSelection[index] = false;
    });
    setSelectedClasses(newSelection);
  };

  const handleSaveSelectedClasses = () => {
    const classesToSave = dataImported.filter(
      (_, index) => selectedClasses[index]
    );
    if (classesToSave.length === 0) {
      alert('Please select at least one class to save.');
      return;
    }
    saveClasses(classesToSave);
  };
  const saveClasses = async (classesToSave) => {
    setIsSavingClasses(true);
    try {
      const saveClassesPromises = classesToSave.map(cls =>
        ProgramService.createProgramClassFromPDF(cls)
      );
      await Promise.all(saveClassesPromises);
      console.log('All classes saved successfully');
      //setShowConfirmDialog(false);
      setDataImported([]);
      setSelectedClasses({});
      setShowModal(false);
      // Optionally refresh the profile or show success message
    } catch (error) {
      console.error('Error saving classes:', error);
      // Handle errors, e.g., show an error message to the user
    } finally {
      setIsSavingClasses(false);
    }
  };
  const getSelectedCount = () => {
    return Object.values(selectedClasses).filter(Boolean).length;
  };
  const showHTML = htmlString => {
    return <div dangerouslySetInnerHTML={{ __html: htmlString }} />;
  };
  const handleImport = () => {
    if (!pdfFile) {
      console.log('No file selected');
      return;
    }
    setShowModal(true);
    setIsImporting(true);
    ProgramService.uploadPDFFile(pdfFile)
      .then(pdfResponse => {
        console.log('PDF imported successfully:', pdfResponse);
        setIsImporting(false);
        setDataImported(pdfResponse.week);
      })
      .catch(error => {
        console.error('Error importing PDF:', error);
        setIsImporting(false);
        setShowModal(false);
      });
  };
  return (
    <>
      <Card className="mb-1">
      <Background
        image={corner4}
        className="bg-card"
        style={{
          borderTopRightRadius: '0.375rem',
          borderBottomRightRadius: '0.375rem'
        }}
      />        
        <Card.Body>
          <Form.Group controlId="formFile" className="mb-3">
            <Form.Label>Upload PDF for CrossFit</Form.Label>
            <Form.Control
              type="file"
              accept=".pdf"
              onChange={handleFileChange}
            />
          </Form.Group>
          <Button
            className="btn btn-sm"
            variant="primary"
            type="button"
            onClick={handleImport}
            disabled={!pdfFile}
          >
            Import
          </Button>
        </Card.Body>
      </Card>
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
        {isImporting ? (
          <>
            <Modal.Header closeButton>
              <Modal.Title>Importing...</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </Modal.Body>
          </>
        ) : (
          <>
            <Modal.Header closeButton>
              <Modal.Title>
                <FontAwesomeIcon icon="tasks" className="me-2" />
                Confirm imported classes
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {dataImported && (
                <div className="mb-3">
                  <p className="text-700">
                    Review and select the classes you want to include.
                    <Badge bg="secondary" className="ms-2">
                      {getSelectedCount()} of {dataImported.length} selected
                    </Badge>
                  </p>
                  <div className="d-flex gap-2 mb-3">
                    <Button
                      variant="outline-primary"
                      size="sm"
                      onClick={handleSelectAll}
                      disabled={isSavingClasses}
                    >
                      <FontAwesomeIcon icon="check-square" className="me-1" />
                      Select All
                    </Button>
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      onClick={handleUnselectAll}
                      disabled={isSavingClasses}
                    >
                      <FontAwesomeIcon icon="square" className="me-1" />
                      Unselect All
                    </Button>
                  </div>
                </div>
              )}
              {dataImported &&
                dataImported.map((c, index) => (
                  <div
                    key={index}
                    className={`border rounded p-3 mb-2 ${
                      selectedClasses[index] ? 'bg-light' : ''
                    }`}
                  >
                    <Form.Check
                      type="checkbox"
                      id={`class-${index}`}
                      checked={selectedClasses[index] || false}
                      onChange={() => handleToggleClass(index)}
                      disabled={isSavingClasses}
                      label={
                        <div
                          className="overflowy-auto"
                          style={{ maxHeight: '100px' }}
                        >
                          <div className="d-flex align-items-center justify-content-between">
                            <div>
                              <Badge bg="info" className="me-2">
                                {c.date}
                              </Badge>
                              <Badge bg="primary">CrossFit</Badge>
                            </div>
                          </div>
                          {showHTML(c.strength)}
                          {showHTML(c.workout)}
                        </div>
                      }
                    />
                  </div>
                ))}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowModal(false)}>
                Close
              </Button>
              <Button
                className="btn btn-sm"
                          variant="primary"
                          onClick={handleSaveSelectedClasses}
                          disabled={isSavingClasses || getSelectedCount() === 0}
                        >
                          {isSavingClasses ? (
                            <>
                              <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                className="me-2"
                              />
                              Saving...
                            </>
                          ) : (
                            <>
                              <FontAwesomeIcon icon="save" className="me-2" />
                              Save {getSelectedCount()} Class{getSelectedCount() !== 1 ? 'es' : ''}
                            </>
                          )}
                        </Button>
            </Modal.Footer>
          </>
        )}
      </Modal>
    </>
  );
};
export default ImportFromPDF;